import { colors } from '../../../../../packages';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  drawer: {
    '& .drawerBody': {
      padding: 0,
    },
  },
  wrapper: {
    flex: 1,
    justifyItems: 'space-between',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 80,
    padding: '20px 16px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  allPromptsBox: {
    display: 'flex',
    gap: '8px',
    maxWidth: '510px',
    flexWrap: 'wrap',
    '& .chip': {
      maxWidth: '510px',
      height: 'unset',
      minHeight: '32px',
      '& .MuiChip-label': {
        whiteSpace: 'initial',
        // paddingTop: '8px',
        // paddingBottom: '8px',
      },
    },
  },
  headerTitle: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 700,
  },
  valuesInput: {
    height: 48,
    padding: 0,
    '& > div': {
      height: 48,
      '& input': {
        fontSize: '14px !important',
      },
    },
    '& .MuiAutocomplete-tag': {
      height: '28px !important',
      fontSize: 14,
    },
  },
  toggleWrap: {
    display: 'flex',
    gap: 32,
    '& div': {
      padding: 0,
    },
  },
  startAdornment: {
    backgroundColor: colors.neutral200,
    padding: 10,
    margin: -16,
    top: -7,
    height: 48,
    width: 48,
    paddingLeft: 18,
    maxHeight: 48,
    '& p': {
      fontWeight: 700,
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 80,
    padding: 16,
    borderTop: `1px solid ${colors.neutral100}`,
  },
  backBtn: {
    width: 40,
    height: 40,
    minWidth: 40,
  },
  form: {
    flex: 1,
  },
  formContent: {
    flex: 1,
    display: 'flex',
    minHeight: 'calc(100vh - 160px)',
    flexDirection: 'column',
    gap: 24,
    padding: 40,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    position: 'relative',
  },
  label: {
    fontSize: 14,
    lineHeight: '20px',
    margin: 0,
  },
});
